import { PermissionsEnum } from "@mindlercare/schema";
import { User } from "../core/types";

export const hasPermissions = (
  user: User | null | undefined,
  permissions: PermissionsEnum | PermissionsEnum[],
): boolean => {
  if (typeof permissions === "string") {
    // handle one case
    return user?.permissions?.includes(permissions) ?? false;
  }
  // handle multiple case
  return permissions?.every(
    (permission) => user?.permissions?.includes(permission) ?? false,
  );
};
